import { getUSerInfo, getBizTeamInfo, getDicts } from '@/api/request'
import { getToken, setClient, setReagentTeamInfo, removeReagentTeamInfo, setToken, removeToken } from '@/plugins/auth'

const user = {
  state: {
    pageInit: false,
    // 记录有几个ajax请求正在执行中
    ajaxCount: 0,
    loginFlag: 0,
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    userInfo: {}
  },

  mutations: {
    updatePageInit: function (state, pageInit) {
      state.pageInit = pageInit
    },
    updateAjaxCount: function (state, count) {
      state.ajaxCount = state.ajaxCount + count
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_LOGINFLAG: (state, loginFlag) => {
      state.loginFlag = loginFlag
    }
  },

  actions: {
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUSerInfo().then(async res => {
          const user = res.user
          const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/img/avatar.png") : process.env.VUE_APP_FILE_API + user.avatar;
          setClient(JSON.stringify(user));
          // 团队业务信息独立缓存，避免团队页面从客户信息中猜测商城团队 ID。
          removeReagentTeamInfo()
          try {
            const teamResponse = await getBizTeamInfo(user.clientId)
            const reagentTeamInfo = teamResponse && teamResponse.data && typeof teamResponse.data === 'object'
              ? teamResponse.data
              : {}
            setReagentTeamInfo(JSON.stringify(reagentTeamInfo))
          } catch (error) {
            // 团队信息获取失败不影响基础登录信息，但也不能继续使用旧团队缓存。
            removeReagentTeamInfo()
          }
          commit('SET_NAME', user.clientName)
          commit('SET_AVATAR', avatar)
          commit('SET_USERINFO', user)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    //设置客服二维码
    async setKefuQRCode() {
      const res_user = await getUSerInfo()
      const res_dict = await getDicts('customer_service_qrcode')//获取区域客服二维码
      const serviceQRCodeData = res_dict.data.find(item => item.dictLabel == res_user.user.unitId)
      if(serviceQRCodeData) {
        localStorage.setItem('serviceQRCode', serviceQRCodeData.dictValue)
      }
    },
  }
}

export default user
